import Color from 'color';
import {createTheme} from '@mui/material/styles';

const primaryColour = Color(window.getComputedStyle(document.documentElement).getPropertyValue('--primary-colour').trim());
const onPrimaryColour = Color(window.getComputedStyle(document.documentElement).getPropertyValue('--on-primary-colour').trim());
const spacingUnit = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--spacing-unit').trim());

const ChTheme = createTheme({
    palette: {
        primary: {
            // light: calculated from palette.primary.main,
            main: primaryColour.toString(),
            // dark: calculated from palette.primary.main,
            contrastText: '#fff',
        },
        tonalOffset: 0.1,
        text: {
            primary: onPrimaryColour.toString(),
            // secondary: default,
            // disabled: default,
            // hint: default,
        },
        divider: Color.rgb(0,0,0).alpha(.12),
        action: {
            active: onPrimaryColour.toString(),
            // hover: default,
            // selected: default,
            // disabled: default,
            // focus: default,
        },
    },
    typography: {
        fontFamily: '"Open Sans", "Arial", sans-serif',
    },
    spacing: spacingUnit,
    props: {
        MuiButtonBase: {
            disableRipple: true,
        },
    },
});

export {
    ChTheme
}